import $ from 'jquery'

class BlockEventCalloutSticky extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
    this.initEvents()
  }

  resolveElements () {
    this.$window = $(window, this);
    this.$stickyEvents = $('.event-callout-sticky__boundary', this);
    this.$stickEventsClose = $('.event-callout-sticky__close', this);
    this.$stickEventsOpen = $('.event-callout-sticky__open', this);
    this.$stickEventsDismiss = $('.event-callout-sticky__dismiss', this);
  }

  initEvents() {
    this.$stickEventsClose.click(this.closeStickyEvents.bind(this));
    this.$stickEventsOpen.click(this.openStickyEvents.bind(this));
    this.$stickEventsDismiss.click(this.dismissStickyEvents.bind(this));
    this.$window.resize(this.closeStickyEvents.bind(this));
    this.$window.scroll(this.closeStickyEvents.bind(this));
  }

  dismissStickyEvents(){
    this.$stickyEvents.addClass('closed');
  }

  openStickyEvents(){
    this.$stickyEvents.addClass('open');
  }

  closeStickyEvents(){
    this.$stickyEvents.removeClass('open');
  }
}

window.customElements.define('flynt-block-event-callout-sticky', BlockEventCalloutSticky, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockEventCalloutSticky/script.js